import $ from 'jquery';
import core from '../core';

const componentSelector = '.js-c-support-missionary';

function bindEvents() {
    $(componentSelector).on('show.bs.collapse', '.collapse', (evt) => {
        const $targetEl = $(evt.target);
        const $componentEl = $targetEl.closest(componentSelector);
        const $toggleButtons = $componentEl.find('[data-bs-toggle="collapse"]');
        const id = $targetEl.attr('id');

        $componentEl.find('[data-bs-target="#' + id + '"]')
            .removeClass('btn-outline-primary')
            .addClass('btn-primary');
    });

    $(componentSelector).on('hide.bs.collapse', '.collapse', (evt) => {
        const $targetEl = $(evt.target);
        const $componentEl = $targetEl.closest(componentSelector);
        const $toggleButtons = $componentEl.find('[data-bs-toggle="collapse"]');
        const id = $targetEl.attr('id');

        $componentEl.find('[data-bs-target="#' + id + '"]')
            .removeClass('btn-primary')
            .addClass('btn-outline-primary');
    });
}

function setup() {
    bindEvents();
}

core.Ready(setup);
